<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 4rem; height: 4rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<div class="animated fadeIn">
						<genericTable :table-data="tableData" :fields="fields" :per-page=20 hover striped bordered small
													caption="<i class='icon-list'></i> List of Resellers">
							<template v-slot:row-actions="row">
								<b-button size="sm" variant="info" class="mr-1" @click="viewReseller(row.row.item.id)">
									<i class="icon-eye"></i> View
								</b-button>
							</template>
						</genericTable>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import genericTable from '@/components/GenericTable';
import toastService from "@/services/toastService";
import resellerService from "@/services/resellerService";

export default {
	name : "ResellerList",
	components : {
		"genericTable" : genericTable
	},
	data : () => {
		return {
			resellerList: [],
			fields: [
				{key: 'id', label: 'ID', sortable: true},
				{key: 'name', label: 'Name', sortable: true, searchable:true},
				{key: 'organization', label: 'Organization', sortable: true, searchable:true},
				{key: 'address', label: 'Address'},
				{key: 'phone', label: 'Phone', searchable:true},
				{key: 'actions', label: 'Actions'}
			],
			loading: false
		}
	},
	methods : {
		getResellerList: function (){
			this.loading = true;
			resellerService.getResellerList((data) => {
				this.resellerList = data;
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch reseller list " + error);
				this.loading = false;
			});
		},
		viewReseller: function (resellerId){
			this.$router.push("/resellers/" + resellerId);
		}
	},
	created() {
		this.getResellerList();
	},
	computed : {
		tableData : function (){
			return this.resellerList;
		}
	}
}
</script>

<style scoped>

</style>
